module.exports = __webpack_public_path__ + "static/img/propTechOperation.9e3bffa0.png";